import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0007',
    ecrans: ['00-2']
});
